import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { Products as Product } from '../../Module_cms/Offers_And_Promotions/Domain/Model/Products';
import { Product as Product2 } from '../../Module_cms/Offers_And_Promotions/Domain/Model/Product';
import debounce from 'lodash.debounce';
import imgDefault from '../../../src/assets/img/image_default_paket.jpg';

interface CustomPickListProps {
  data: Product[];                             // Data paginada del source
  pageSize?: number;                           // Tamaño de página
  sourceSearchValue: string;                   // Texto de búsqueda del source
  onSourceSearchChange: (value: string) => void;
  sourcePage: number;                          // Página actual del source
  onSourcePageChange: (page: number) => void;
  sourceTotalCount: number;                    // Total de items del source (para paginación)
  onChange?: (selected: number) => void;    // Callback para enviar target al padre
  ProductObtained: Product2 | undefined
}

export const CustomOrderList: React.FC<CustomPickListProps> = ({
  data,
  pageSize = 5,
  sourceSearchValue,
  onSourceSearchChange,
  sourcePage,
  onSourcePageChange,
  sourceTotalCount,
  onChange,
  ProductObtained
}) => {
  // const [target, setTarget] = useState<Product2 | undefined>(
  //   {
  //           productId: 0,
  //           productName: "",
  //           mainImage: "",
  //           salePrice: 0,
  //           discountPrice: 0,
  //   }
  // );

    const [target, setTarget] = useState<Product2 | undefined>(undefined);
  const [selectedSource, setSelectedSource] = useState<number[]>([]);
  const [inputValue, setInputValue] = useState(sourceSearchValue);


  const debouncedSearch = useCallback(
    debounce((searchValue: string) => {
      onSourceSearchChange(searchValue);
    }, 500),
    [onSourceSearchChange]
  );

  function onloadlistObtained(){
    if(ProductObtained){
      setTarget(ProductObtained);
      console.log("onloadlistObtained", ProductObtained);
    }
  }

  useEffect(() => {
      onloadlistObtained();
  }, [ProductObtained]);

  useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };
}, [debouncedSearch]);

  useEffect(() => {
    if (target) {
      const selectedId = Number(target.productId);
      onChange?.(selectedId);
    } else {
      onChange?.(0);
    }
        
    }, [target]);

  const handleSourceSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value); // Actualización inmediata del input
    debouncedSearch(value); // Búsqueda con debounce
  };


 const moveToTarget = () => {
  // const toMove = data.filter((item) => 
  //   selectedSource.includes(item.productId) &&
  //   !target.some((t:any) => t.productId === item.productId) // ✅ evitar duplicados
  // );

  const toMove = data.find((item) =>
    selectedSource.includes(item.productId)
  );

  if (target) return;

  if (!toMove) return; // Nada nuevo que mover



   const newTarget: Product2 = {
    productId: toMove.productId,
    productName: toMove.productName ?? "",
    mainImage: toMove.mainImage ?? "",
    salePrice: toMove.salePrice,
    discountPrice: toMove.discountPrice,
  };

  setTarget(newTarget);

   // Solo enviar los IDs al padre
    // const selectedIds = updated.map((item) => item.productId);
    // const firstId = selectedIds[0];
    onChange?.(Number(newTarget.productId));
    console.log(Number(newTarget.productId));

    setSelectedSource([]);
};

// const removeFromTarget = (productId: number) => {
//   setTarget((prev: any) => {
//     const updated = prev.filter((item:any) => item.productId !== productId);
//     const selectedIds = updated.map((item: any) => item.productId);
//     const firstId = selectedIds[0];
//     onChange?.(firstId); // ← Solo IDs
//     return updated;
//   });
// };

const removeFromTarget = () => {
  setTarget(undefined);
  onChange?.(0); // o `null`, dependiendo de cómo manejes la ausencia de producto en el padre
};

const itemTemplate = (item: Product) => {
        return (
            <div className="content-dproduct">
                <img src={`${item.mainImage ? item.mainImage : imgDefault}`} alt={item.productName} />
                <div className="text">
                    <span className='product-name'>{item.productName}</span>
                    <div className=''>
                        <i className="pi pi-tag text-sm"></i>
                        <span>{item.categoryName}</span>
                    </div>
                </div>
                <span className="price"><span>S/</span> {item.salePrice}</span>
            </div>
        );
    };

  return (
    <div  className='content-pick-list'>
      {/* Source List */}
      <div className='col-list'>
        <p>Disponibles</p>
        <div className='content-search'>
          <input
            className='input-search'
            type="text"
            placeholder="Buscar..."
            value={inputValue}
            onChange={handleSourceSearchChange}
          />
          <FontAwesomeIcon icon={icon({name: 'search'})} />
        </div>
        <ul className='content-items'>
          {data.map((item) => (
            <li key={`source-${item.productId}`}>
              <label className='d-flex'>
                <input
                  style={{width: 20}}
                  type="checkbox"
                  checked={selectedSource.includes(item.productId)}
                  onChange={(e) => {
                    const selected = e.target.checked ? [item.productId] : [];
                    setSelectedSource(selected);
                  }}
                />
                {itemTemplate(item)}
              </label>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '8px' }}>
          <button type='button' className='btn btn-dark' disabled={sourcePage <= 1} onClick={() => onSourcePageChange(sourcePage - 1)}>
            Prev
          </button>
          <button
          type='button'
          className='btn btn-dark ms-2'
            disabled={sourcePage >= Math.ceil(sourceTotalCount / pageSize)}
            onClick={() => onSourcePageChange(sourcePage + 1)}
          >
            Next
          </button>
        </div>
      </div>

      {/* Control Buttons */}
      <div className='col-btn' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '1rem' }}>
        <button type='button' className='btn btn-dark' onClick={moveToTarget}>&gt;&gt;</button>
        {/* <button onClick={moveToSource}>&lt;&lt;</button> */}
      </div>

      {/* Target List */}
      <div className='col-list'>
        <p>Seleccionado</p>
        <div className='content-item'>
          {
            target && (
               
                   <div className='content-view-product' key={`target-${target.productId}`}>
                        <img style={{maxWidth: 200 }} src={target.mainImage} alt={target.productName} />
                        <div className='content-data-product'>
                          <span>{target.productName}</span>
                          {/* <span>{item.sku}</span> */}
                          <span className='salePrice'><b>S/ {target.salePrice}</b></span>
                          <span className='discountPrice'>S/ {target.discountPrice}</span>
                        </div>
                        <div className='content-btn-product'>
                          <button type='button' className="btn btn-danger ms-2" onClick={()=>removeFromTarget()}><FontAwesomeIcon icon={icon({name: 'trash'})} /></button>
                        </div>
                   </div>
                
            )
          }
        </div>
      </div>
    </div>
  );
};
